// extracted by mini-css-extract-plugin
export default {"footer":"C_br","row":"C_cK","menuColumn":"C_cL","trademarks":"C_cM"};